import { Fragment, useContext } from 'react';
import { match } from 'ts-pattern';

import DialogContainer from '~/domains/design-system/components/Dialog/DialogContainer';
import useAnimatedDialogModals from '~/domains/common/context/useAnimatedDialogModals';

import GamecenterEntriesBulkCSVModal from '~/domains/contest/domains/gamecenter/domains/common/components/GamecenterEntriesPageScheduled/GamecenterEntriesBulkCSV/GamecenterEntriesBulkCSVModal/GamecenterEntriesBulkCSVModal';
import GamecenterStandingsExportModal from '~/domains/contest/domains/gamecenter/domains/common/components/GamecenterStandingsExport/GamecenterStandingsExportModal/GamecenterStandingsExportModal';
import GamecenterTeeTimesModal from '~/domains/contest/domains/gamecenter/domains/player/components/TeeTimesModal/TeeTimesModal';

import { GamecenterModalsContext } from './GamecenterModalsContext';

function GamecenterModals() {
  const { modals, closeModal, isCloseDisabled } = useContext(GamecenterModalsContext);
  const { modalsCache, activeModal, closingModal } = useAnimatedDialogModals({
    modals,
  });

  return (
    <DialogContainer
      isOpen={!!modals.length}
      onClose={isCloseDisabled ? undefined : closeModal}
      lockScroll
    >
      {modalsCache.map((modal) => {
        const commonProps = {
          onClose: closeModal,
          isOpen: activeModal === modal && closingModal !== modal,
        };

        return (
          <Fragment key={modal.type}>
            {match(modal)
              .returnType<React.ReactNode>()
              .with({ type: 'GamecenterEntriesBulkCSVModal' }, (rest) => (
                <GamecenterEntriesBulkCSVModal {...rest} {...commonProps} />
              ))
              .with({ type: 'GamecenterTeeTimesModal' }, (rest) => (
                <GamecenterTeeTimesModal {...rest} {...commonProps} />
              ))
              .with({ type: 'GamecenterStandingsExportModal' }, (rest) => (
                <GamecenterStandingsExportModal {...rest} {...commonProps} />
              ))
              .otherwise(() => null)}
          </Fragment>
        );
      })}
    </DialogContainer>
  );
}

export default GamecenterModals;
